import { type BaseLoyaltyRepository } from "../../_Bases/BaseLoyaltyRepository";
import { type LocalDatabaseLoyalty, type LoyaltyUnion } from "../../_Bases/BaseLoyaltyRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBLoyaltyRepository extends BaseIndexedDBRepository<
    LocalDatabaseLoyalty,
    number
> implements BaseLoyaltyRepository {
    public readonly source: InternalIndexedDBDatabase["loyalty"];
    protected readonly dataTypeName = "id";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.loyalty;
    }

    public getByType(id: string, type: LoyaltyUnion): Promise<Array<LocalDatabaseLoyalty>> {
        return this.source
            .where({
                uuid: id,
                type,
            })
            .toArray();
    }
}
